<div class="dashboard-container">
  <!-- Green Header with Marquee -->
  <header class="dashboard-header">
    <div class="header-content">
      <!-- Logo on the far left -->
      <div class="logo-container">
        <a href="/home" class="logo-link">
          <img src="../../assets/images/800x800_logo.png" alt="Agro Informer Logo" class="header-logo">
        </a>
      </div>

      <!-- Marquee in the center -->
      <div class="marquee-container">
        <marquee behavior="scroll" direction="left" class="marquee-text">
          {{ marqueeText }}
        </marquee>
      </div>
    </div>
  </header>

  <div class="dashboard-body">
    <!-- Light Gray Sidebar -->
    <aside class="sidebar" [class.collapsed]="isSidebarCollapsed">
      <div class="sidebar-header">
        <button class="toggle-btn" (click)="toggleSidebar()">
          <i class="fas" [class.fa-bars]="!isSidebarCollapsed" [class.fa-chevron-right]="isSidebarCollapsed"></i>
        </button>
        <span *ngIf="!isSidebarCollapsed" class="sidebar-title">Agro Informer</span>
      </div>

      <nav class="sidebar-nav">
        <span *ngIf="isUserAgroModerator">
          <div *ngFor="let menuItem of menuItemsMod" class="menu-item">
            <div class="menu-header" (click)="toggleSubMenu(menuItem)">
              <i class="fas" [class]="menuItem.icon"></i>
              <span *ngIf="!isSidebarCollapsed" class="menu-text">{{ menuItem.title }}</span>
              <i *ngIf="!isSidebarCollapsed" class="fas arrow" [class.fa-chevron-down]="menuItem.isOpen"
                [class.fa-chevron-right]="!menuItem.isOpen"></i>
            </div>

            <div *ngIf="menuItem.isOpen && !isSidebarCollapsed" class="submenu">
              <a *ngFor="let subItem of menuItem.subItems" href="javascript:void(0)" class="submenu-item"
                [class.active]="subItem.id === activeContent" (click)="setActiveContent(subItem.id)">
                <i class="fas" [class]="subItem.icon"></i>
                <span class="submenu-text">{{ subItem.title }}</span>
              </a>
            </div>
          </div>
        </span>

        <span *ngIf="!isUserAgroModerator && isUserAgroUser">
          <div *ngFor="let menuItem of menuItemsUser" class="menu-item">
            <div class="menu-header" (click)="toggleSubMenu(menuItem)">
              <i class="fas" [class]="menuItem.icon"></i>
              <span *ngIf="!isSidebarCollapsed" class="menu-text">{{ menuItem.title }}</span>
              <i *ngIf="!isSidebarCollapsed" class="fas arrow" [class.fa-chevron-down]="menuItem.isOpen"
                [class.fa-chevron-right]="!menuItem.isOpen"></i>
            </div>

            <div *ngIf="menuItem.isOpen && !isSidebarCollapsed" class="submenu">
              <a *ngFor="let subItem of menuItem.subItems" href="javascript:void(0)" class="submenu-item"
                [class.active]="subItem.id === activeContent" (click)="setActiveContent(subItem.id)">
                <i class="fas" [class]="subItem.icon"></i>
                <span class="submenu-text">{{ subItem.title }}</span>
              </a>
            </div>
          </div>
        </span>

        <span *ngIf="!isUserAgroModerator && !isUserAgroUser">
          <div *ngFor="let menuItem of menuItemsAnonymous" class="menu-item">
            <div class="menu-header" (click)="toggleSubMenu(menuItem)">
              <i class="fas" [class]="menuItem.icon"></i>
              <span *ngIf="!isSidebarCollapsed" class="menu-text">{{ menuItem.title }}</span>
              <i *ngIf="!isSidebarCollapsed" class="fas arrow" [class.fa-chevron-down]="menuItem.isOpen"
                [class.fa-chevron-right]="!menuItem.isOpen"></i>
            </div>

            <div *ngIf="menuItem.isOpen && !isSidebarCollapsed" class="submenu">
              <a *ngFor="let subItem of menuItem.subItems" href="javascript:void(0)" class="submenu-item"
                [class.active]="subItem.id === activeContent" (click)="setActiveContent(subItem.id)">
                <i class="fas" [class]="subItem.icon"></i>
                <span class="submenu-text">{{ subItem.title }}</span>
              </a>
            </div>
          </div>
        </span>
      </nav>

      <div class="contact-info" *ngIf="!isSidebarCollapsed">
        <div class="contact-company">Agro Informer d.o.o.</div>
        <div class="contact-phone">+387 55 423 873</div>
        <div class="contact-email">office@agroinformer.co</div>
      </div>

      <div class="client-slideshow">
        <div class="client-image-container">
          <img *ngIf="currentClientImage" [src]="currentClientImage" [alt]="'Our Client ' + currentClientIndex"
            class="client-image" [style.animation-delay]="'0s'">
        </div>
      </div>
    </aside>

    <!-- Main Content Area -->
    <main class="main-content">
      <!-- <div class="content-header">
        <h2>{{ getActiveContentTitle() }}</h2>
      </div> -->

      <div class="content-body">
        <ng-container [ngSwitch]="activeContent">
          <!-- <app-users *ngSwitchCase="'users'"></app-users> -->
          <app-artikli *ngSwitchCase="'artikli'"></app-artikli>
          <app-jedinice-mjere *ngSwitchCase="'jedinice-mjere'"></app-jedinice-mjere>
          <app-opisi *ngSwitchCase="'opisi'"></app-opisi>
          <app-ponude *ngSwitchCase="'ponude'"></app-ponude>
          <app-potraznje *ngSwitchCase="'potraznje'"></app-potraznje>
          <app-poslovni-imenik *ngSwitchCase="'poslovni-imenik'"></app-poslovni-imenik>
          <app-firme *ngSwitchCase="'firme'"></app-firme>
          <app-kretanje-cijena *ngSwitchCase="'kretanje-cijena'"></app-kretanje-cijena>
          <app-kretanje-cijena-pdf *ngSwitchCase="'kretanje-cijena-pdf'"></app-kretanje-cijena-pdf>
          <app-produzeci-saradnje *ngSwitchCase="'produzeci-saradnje'"></app-produzeci-saradnje>
          <app-djelatnosti-firme *ngSwitchCase="'djelatnosti-firme'"></app-djelatnosti-firme>
          <app-oblasti-firme *ngSwitchCase="'oblasti-firme'"></app-oblasti-firme>
          <app-statusi-firme *ngSwitchCase="'statusi-firme'"></app-statusi-firme>
          <app-gradovi *ngSwitchCase="'gradovi'"></app-gradovi>
          <app-drzave *ngSwitchCase="'drzave'"></app-drzave>
          <app-obavjestenja *ngSwitchCase="'obavjestenja'"></app-obavjestenja>
          <app-korisnici *ngSwitchCase="'korisnici'"></app-korisnici>
          <app-kontakti *ngSwitchCase="'kontakti'"></app-kontakti>
          <app-pregled-ip *ngSwitchCase="'ip-logovi'"></app-pregled-ip>
          <app-login *ngSwitchCase="'login'"></app-login>
          <app-mobilne-ponude *ngSwitchCase="'mobilne-ponude'"></app-mobilne-ponude>
          <app-mobilne-potraznje *ngSwitchCase="'mobilne-potraznje'"></app-mobilne-potraznje>
          <app-kurs-eura *ngSwitchCase="'kurs-eura'"></app-kurs-eura>
          <app-nudjene-cijene *ngSwitchCase="'nudjene-cijene'"></app-nudjene-cijene>
          <app-realizacije *ngSwitchCase="'realizacije'"></app-realizacije>
          <app-otkupne-cijene *ngSwitchCase="'otkupne-cijene'"></app-otkupne-cijene>
          <app-vazna-obavjestenja *ngSwitchCase="'vazna-obavjestenja'"></app-vazna-obavjestenja>
          <app-registrovani-kontakt *ngSwitchCase="'poruke-registrovanih-korisnika'"></app-registrovani-kontakt>
          <app-anonimni-kontakt *ngSwitchCase="'poruke-anonimnih-korisnika'"></app-anonimni-kontakt>
          <app-cijene-ino *ngSwitchCase="'cijene-na-ino'"></app-cijene-ino>
          <!-- <app-settings *ngSwitchCase="'settings'"></app-settings>
          <app-dashboard-home *ngSwitchCase="'dashboard'"></app-dashboard-home> -->
          <div *ngSwitchDefault class="welcome-message">
            <h3>Dobrodošli na sajt Agro Informer, {{ username }}</h3>
            <p>Odaberite opciju iz menija za upravljanje sistemom.</p>
          </div>
        </ng-container>
      </div>
    </main>
  </div>
</div>